<!--  -->
<template>
  <div class="relevant">
    <div class="titleInfo">
      <div class="bt">
        <span class="left">相关行业舆情</span>
        <!-- <span class="right">
          <span>订阅</span>
          <img src="../assets/dy.png" alt="" />
        </span>-->
      </div>
      <div v-if="Object.keys(info).length!=0">
        <el-tag size="mini" v-if="title.labelo != null">
          {{
          title.labelo
          }}
        </el-tag>
        <el-tag size="mini" v-if="title.labelt != null">
          {{
          title.labelt
          }}
        </el-tag>
        <el-tag size="mini" v-if="title.industrylabel != null">
          {{
          title.industrylabel
          }}
        </el-tag>
        <el-tag size="mini" v-if="title.industrylabelt != null">
          {{
          title.industrylabelt
          }}
        </el-tag>
        <el-tag size="mini" v-if="title.lables != null">
          {{
          title.lables
          }}
        </el-tag>
        <el-tag size="mini" v-if="title.didbudget != null" type="warning">
          {{
          title.didbudget
          }}
        </el-tag>
        <el-tag size="mini" v-if="title.didnotice != null" type="danger">
          {{
          title.didnotice
          }}
        </el-tag>

        <ul style="padding-bottom:50px;">
          <li @click="toDetail(item.id)" v-for="(item, index) in info" :key="index">
            <p class="title">
              {{
              item.translationtitle
              ? item.translationtitle
              : item.originaltitle
              }}
            </p>
            <!-- <p class="txt">{{ item.consultingtext }}</p> -->
          </li>
        </ul>
      </div>
      <div v-else>
        <p style="color:#c0c0c0;height:300px;line-height:300px;text-align:center;">没有相关的行业资讯信息</p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { API_1, Global } from '@/conf/api'
export default {
  //import引入的组件需要注入到对象中才能使用
  name: 'relevant',
  components: {},
  props: ['info', 'title'],
  data() {
    //这里存放数据
    return {}
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toDetail(id) {
      this.$router.push({
        path: '/info',
        query: {
          id: id,
        },
      })
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
/deep/ .el-carousel__button {
  background: #0f4d72;
}
/deep/ .el-carousel__container {
  height: 400px;
}
.relevant {
  display: inline-block;
  width: 320px;
  background: #fff;
  border-radius: 4px;
  text-align: center;
  vertical-align: top;
  margin-left: 20px;

  .titleInfo {
    width: 240px;
    .bt {
      margin-bottom: 10px;
      .left {
        font-weight: bold;
      }
      .right {
        span {
          margin-right: 10px;
          font-size: 16px;
          color: #5c5c5c;
        }
        float: right;
        margin-right: 20px;
      }
    }
    p {
      margin-bottom: 10px;
    }
    .el-tag {
      margin-right: 5px;
      color: #0f4d72;
      background: rgba(15, 77, 114, 0.1);
      height: 24px;
      line-height: 21px;
      border: 1px solid transparent;
    }
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
    padding-top: 10px;
    text-align: left;
    margin-left: 40px;
  }

  ul {
    li {
      width: 240px;
      // height: 50px;
      border-bottom: 1px solid #eee;
      text-align: left;
      margin: 0 auto;
      padding: 10px 0;
      line-height: 22px;
      cursor: pointer;
      .title,
      .txt {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .title {
        font-size: 16px;
        color: #0f4d72;
        &:hover {
          color: #178cd1;
        }
      }
      .txt {
        font-size: 14px;
        color: #999;
      }
    }
  }
}
</style>
